var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.currentmatter)?_c('div',{staticClass:"top-matter-container timeline-scroller-gap",class:{
    'dynamic-visible': _vm.dynamicVisible,
  }},[_c(_vm.currentmatter,{tag:"component"})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }